'use client';

import React, { useState, useRef, useEffect } from 'react';
import Image from 'next/image';
import { useAuth } from '@/lib/AuthContext';
import styles from '../styles/Navbar.module.css';
import Swal from 'sweetalert2';

export function Navbar() {
    const { user, logout } = useAuth();
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const dropdownRef = useRef<HTMLDivElement>(null);

    // Close dropdown when clicking outside
    useEffect(() => {
        function handleClickOutside(event: MouseEvent) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
                setDropdownOpen(false);
            }
        }
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const handleLogout = async () => {
        try {
            await logout();
            setDropdownOpen(false);
            // Optional: Redirect or show toast is handled by AuthContext state change usually
        } catch (error) {
            console.error('Logout failed', error);
            Swal.fire({
                icon: 'error',
                title: 'Logout Failed',
                text: 'Something went wrong. Please try again.',
            });
        }
    };

    if (!user) return null;

    const displayName = user.name || 'User';
    const userEmail = user.email || '';

    return (
        <nav className={styles.navbar}>
            <div className={styles.left}>
                <Image
                    src="/images/logo.svg"
                    alt="Smarten Meet"
                    width={140}
                    height={35}
                    priority
                    style={{ width: 'auto', height: '35px' }}
                />
            </div>

            <div className={styles.navCenter}>
                <div className={styles.platformContainer}>
                    <div className={styles.platformItem}>
                        <div className={styles.platformIcon}>
                            <Image src="/images/account.svg" alt="Accounting" width={32} height={32} />
                        </div>
                        <div className={styles.platformText}>
                            <span className={styles.platformTitle}>NEPAL ACCOUNTING</span>
                            <span className={styles.platformTagline}>Don&#39;t just track profit, predict it.</span>
                        </div>
                    </div>

                    <div className={styles.platformItem}>
                        <div className={styles.platformIcon}>
                            <Image src="/images/manufactor.svg" alt="Manufacturing" width={32} height={32} />
                        </div>
                        <div className={styles.platformText}>
                            <span className={styles.platformTitle}>SMART MANUFACTURING</span>
                            <span className={styles.platformTagline}>The heartbeat of your factory.</span>
                        </div>
                    </div>

                    <div className={styles.platformItem}>
                        <div className={styles.platformIcon}>
                            <Image src="/images/elearning.svg" alt="e-Learning" width={32} height={32} />
                        </div>
                        <div className={styles.platformText}>
                            <span className={styles.platformTitle}>e-Learning Platform</span>
                            <span className={styles.platformTagline}>Train your Brain Online.</span>
                        </div>
                    </div>
                </div>
            </div>

            <div className={styles.right} ref={dropdownRef}>
                <button
                    className={styles.profileButton}
                    onClick={() => setDropdownOpen(!dropdownOpen)}
                    aria-label="User menu"
                >
                    <div className={styles.placeholderAvatar}>
                        {displayName.charAt(0).toUpperCase()}
                    </div>
                </button>

                {dropdownOpen && (
                    <div className={styles.dropdown}>
                        <div className={styles.userInfo}>
                            <span className={styles.userName}>{displayName}</span>
                            <span className={styles.userEmail}>{userEmail}</span>
                        </div>

                        <button className={`${styles.menuItem} ${styles.danger}`} onClick={handleLogout}>
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                                <polyline points="16 17 21 12 16 7"></polyline>
                                <line x1="21" y1="12" x2="9" y2="12"></line>
                            </svg>
                            Sign out
                        </button>
                    </div>
                )}
            </div>
        </nav>
    );
}
